export const Permissions = {
  ViewCustomUser: 'view_customuser',
  AddCustomUser: 'add_customuser',
  ChangeCustomUser: 'change_customuser',
  MoveCustomUser: 'can_move_user_team',
  ViewDriver: 'view_driver',
  AddDriver: 'add_driver',
  ChangeDriver: 'change_driver',
  ViewTeam: 'view_team',
  AddTeam: 'add_team',
  ChangeTeam: 'change_team',
  ViewDocument: 'view_document',
  AddDocument: 'add_document',
  ChangeDocument: 'change_document',
  ViewIssue: 'view_issue',
  AddIssue: 'add_issue',
  ChangeIssue: 'change_issue',
  ViewJob: 'view_job',
  AddJob: 'add_job',
  ChangeJob: 'change_job',
  ViewLineItem: 'view_lineitem',
  AddLineItem: 'add_lineitem',
  ChangeLineItem: 'change_lineitem',
  ViewFileAttachment: 'view_fileattachment',
  AddFileAttachment: 'add_fileattachment',
  ChangeFileAttachment: 'change_fileattachment',
  ViewLoad: 'view_load',
  AddLoad: 'add_load',
  ChangeLoad: 'change_load',
  ViewLoadStop: 'view_loadstop',
  AddLoadStop: 'add_loadstop',
  ChangeLoadStop: 'change_loadstop',
  ViewBackgroundCheck: 'view_backgroundcheck',
  ChangeBackgroundCheck: 'change_backgroundcheck',
  ViewPowerUnit: 'view_powerunit',
  ChangePowerUnit: 'change_powerunit',
  ViewStatement: 'view_statement',
  AddStatement: 'add_statement',
  ChangeStatement: 'change_statement',
  ReimburseStatement: 'reimburse_statement',
  IssuePaymentStatement: 'issuepayment_statement',
  ViewStopCheckin: 'view_stopcheckin',
  ViewBookmarkedLoad: 'view_bookmarkedload',
  ViewSchedule: 'view_schedule',
  ViewBroker: 'view_broker',
  AddBroker: 'add_broker',
  ChangeBroker: 'change_broker',
  ViewInvoice: 'view_invoice',
  AddInvoice: 'add_invoice',
  ChangeInvoice: 'change_invoice',
  ViewQA: 'view_qa',
  ViewContactedLoad: 'view_contactedload',
  ViewReferral: 'view_referral',
  AddEquipment: 'add_equipment',
  ChangeEquipment: 'change_equipment',
  ViewEquipment: 'view_equipment',
  ViewCredential: 'view_credential',
  ViewFuelReceipt: 'view_fuelreceipt',
  AddFuelReceipt: 'add_fuelreceipt',
  ChangeFuelReceipt: 'change_fuelreceipt',
  AddPermission: 'add_permission',
  ViewPermissionGroup: 'view_group',
  ChangePermissionGroup: 'change_group',
  ChangeTeamPermission: `change_teampermission`,
  ViewPlaidAccountNumber: 'view_plaid_account_number',
  ViewSafetyTool: 'view_safetytool',
  CanChangeTeamProduct: 'can_change_team_product',
  CanAddOrder: 'add_order',
  CanAddOrderWithOverrides: 'add_order_with_overrides',
  EditStripeSubscription: 'edit_stripe_subscription',
  RefundStripeSubscription: 'refund_stripe_subscription',
  ViewStripeSubscriptionDevTools: 'view_stripe_subscription_dev_tools',
  CreateStaffUser: 'create_staff_user',
  ViewEmploymentJob: 'view_employmentjob',
  AddEmploymentJob: 'add_employmentjob',
  ChangeEmploymentJob: 'change_employmentjob',
  DeleteEmploymentJob: 'delete_employmentjob',
  FilterTeamByProduct: 'filter_team_by_product',
  ViewCustomLoad: 'view_customload',
  AddCustomLoad: 'add_customload',
  ChangeCustomLoad: 'change_customload',
  ViewHomeFeed: 'view_home_feed',
  ChangeAutoInvoiceBroker: 'change_auto_invoice_broker',
  CanReonboardTeam: 'can_reonboard_team',
  ChangeBrokerOnPastJob: 'change_broker_on_past_job',
  ResetUser: 'can_reset_user',
  ViewSFMS: 'can_view_sfms',
  CanChangeEDILoad: 'change_ediload',
  DeactivateCheckrCandidate: 'deactivate_checkr_candidate',
  ProgramEnrollment: 'program_enrollment',
  ViewFeasibilityStat: 'view_feasibilitystat',
  CanChangeFeasibilityStat: 'change_feasibilitystat',
  ViewCTXLoad: 'view_ctxload',
  OrderBgcPackageTwo: 'order_bgc_package_two',
  TrailerInvoiceParsing: 'trailer_invoice_parsing',
}

export function hasPermission(
  { permissions, isSuperUser, featureFlags }: any,
  permission: any,
  featureFlag?: any // this is a synchronous check for feature flags
) {
  if (featureFlag && featureFlags && featureFlags[featureFlag] === false) return false

  if (!permissions) return false
  if (isSuperUser) return true
  return permissions.includes(permission)
}
